import { getWindow } from './dom.js';
export const supportsHas = () =>
  getWindow()?.CSS?.supports?.('selector(:has(+ *))');
